<template>
  <div class="cve-name-and-link-table-cell">
    <div class="cve-name-and-link-table-cell__name">
      <a :href='link' target='_blank'> {{ name }} </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CveNameAndLinkTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  computed: {
    name() {
      return this.item[this.column.field].name;
    },
    link() {
      return this.item[this.column.field].url || '';
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/assets/styles/design-system';

.cve-name-and-link-table-cell {
  &__name {
    a {
      color: var(--text-primary);

      &:hover {
        color: var(--brand-primary);
      }
    }
  }
}
</style>
